/* global axios */

import ApiClient from './ApiClient';

declare const axios: any;

export interface CannedResponseParams {
  searchKey?: string;
  filter?: string;
  teamIds?: number[];
}

class CannedResponseAPI extends ApiClient {
  constructor() {
    super('canned_responses', { accountScoped: true });
  }

  get(params: CannedResponseParams = {}, config: any = {}) {
    const queryParams: Record<string, string | number | number[]> = {};

    if (params.searchKey) queryParams.search = params.searchKey;
    if (params.filter) queryParams.filter = params.filter;
    if (params.teamIds?.length) queryParams.team_ids = params.teamIds;

    return axios.get(this.url, { params: queryParams, ...config });
  }
}

export default new CannedResponseAPI();
